import { Folder } from "@mui/icons-material";
import { Chip } from "@mui/material";
import { useState } from "react";
import { User } from "../../../../app/backendTypes";
import BlackDuckProjectsDialog from "./BlackDuckProjectsDialog";

export default function BlackDuckProjectsAction(props: { user: User }) {
  const { user } = props;

  const [open, setOpen] = useState(false);

  return (
    <>
      <Chip
        icon={<Folder />}
        variant="outlined"
        color="secondary"
        label="Projects"
        onClick={() => setOpen(true)}
      />
      <BlackDuckProjectsDialog open={open} setOpen={setOpen} user={user} />
    </>
  );
}
